import { navbarMainTabs, navbarExtraServices } from 'src/lib'
import { Logo, MenuCheeseburger } from 'src/assets'
import NavbarHeaderItem from './NavbarHeaderItem'
import { useMainState } from 'src/store'
import { Button } from 'src/components'
import { useIsMobile } from 'src/utils'

interface Props {
  toggleMenu: () => void
  isOnTopOfPage: boolean
}

const NavbarHeader = ({ toggleMenu, isOnTopOfPage }: Props) => {
  const user = useMainState((state) => state.user)
  const isMobile = useIsMobile()

  //to do individual strings
  const classes = [
    'px-[20px]',
    'min-h-[60px]',
    'h-[60px]',
    'right-0',
    'left-0',
    'top-0',
    'border-b',
    'flex',
    'items-center',
    'justify-between',
    'min-w-full',
    'absolute',
    'transition',
    'z-[500]',
    isOnTopOfPage
      ? 'bg-transparent border-transparent'
      : 'bg-white border-gray',
  ]

  return (
    <div className={classes.join(' ')}>
      <div className='h-full flex-center gap-[10px]'>
        <Logo />
        {!isMobile &&
          navbarMainTabs.map((item) => (
            <NavbarHeaderItem key={item.name} {...{ ...item, isOnTopOfPage }} />
          ))}
      </div>
      <div className='h-full flex-center gap-[10px]'>
        {isMobile ? (
          <Button
            icon={<MenuCheeseburger />}
            size='m'
            onClick={toggleMenu}
            theme='secondary-ghost'
          />
        ) : (
          navbarExtraServices.map((item) => (
            <NavbarHeaderItem key={item.name} {...{ ...item, isOnTopOfPage }} />
          ))
        )}
      </div>
    </div>
  )
}

export default NavbarHeader
